import { ePaymentPeriod } from '../../../ui-toolkit/enums/ePaymentPeriod';

export default function generatePaymentPeriodOptions() {
  return Object.entries({
    /*tslint:disable:object-literal-sort-keys*/
    Annual: ePaymentPeriod.annual,
    'Semi Annual': ePaymentPeriod.semi_annual,
    Quarterly: ePaymentPeriod.quarterly,
    Monthly: ePaymentPeriod.monthly,
    /*tslint:enable:object-literal-sort-keys*/
  }).map((entry) => ({ label: entry[0], value: entry[1] }));
}
